import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import { getWishlist } from '../../utils/apiRoutes';

// export const getAllWishlistUsersAsync = async () => {
//   // createAsyncThunk(`${moduleName}/getAllWishlistUsersAsync`,
//   // async (payload) => {
//   const response = await axiosAtheneum({
//     method: 'GET',
//     url: getWishlist(),
//   });
//   const data = response.data;
//   return data;
//   // });
// };

export const getAllWishlistUsersAsync = createAsyncThunk(
  `${moduleName}/getAllWishlistUsersAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'GET',
      url: getWishlist(),
    });
    const data = response.data;
    return data;
  }
);


const wishlistSlice = createSlice({
  name: `${moduleName}/Wishlist`,
  initialState: {
    loading: false,
    wishlist: [],
  },
  reducers: {},
  extraReducers: {
    [getAllWishlistUsersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllWishlistUsersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.wishlist = action.payload;
    },
    [getAllWishlistUsersAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default wishlistSlice.reducer;
